import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import slugify from '../../utils/slugify';

interface Props {
  label: string;
  show: boolean;
  selected: string;
  handleSelect: (selected: string) => void;
  options: string[];
}

function Select(props: Props) {
  const { selected = '' } = props;
  
  if (!props.show) {
    return null;
  }

  const handleChange = (e) => {
    props.handleSelect(e.target.value);
  };

  return (
    <FormControl style={{ marginRight: 15, minWidth: 200 }}>
      <InputLabel shrink>{props.label + 's'}</InputLabel>
      <NativeSelect value={selected} onChange={handleChange}>
        <option value="">Select {props.label}</option>
        {props.options.map(o => <option key={slugify(o)} value={slugify(o)}>{o}</option>)}
      </NativeSelect>
    </FormControl>
  );
}

export default Select;
